<script>
    import LySection from '../components/LySection.svelte';

    /**
     * @type {{
     *     tag?: string,
     *     padding?: boolean | string,
     *     border?: boolean | string,
     *     bg?: boolean | string,
     *     mt?: number | boolean | string,
     *     mb?: number | boolean | string,
     *     wrapper?: boolean | string,
     *     shadow?: boolean | string,
     *     center?: boolean | string,
     *     children?: import("svelte").Snippet,
     *     [key: string]: any,
     * }}
     */
    let {
        tag = 'div',
        padding = false,
        border = false,
        bg = false,
        mt = 0,
        mb = 0,
        wrapper = false,
        shadow = false,
        center = false,
        children,
        ...restProps
    } = $props();
</script>

<LySection
    {...restProps}
    {tag}
    {padding}
    {border}
    {bg}
    {mt}
    {mb}
    {shadow}
    {wrapper}
    rounded={true}
    addClass={center ? 'text-center' : ''}>
    {@render children?.()}
</LySection>
